import html from '../img/svg/skills/html.svg'
import photoshop from '../img/svg/skills/photoshop.svg'
import css from '../img/svg/skills/css.svg'
import angular from '../img/svg/skills/angular.svg'
import javascript from '../img/svg/skills/javascript.svg'
import react from '../img/svg/skills/react.svg'
import php from '../img/svg/skills/php.svg'
import python from '../img/svg/skills/python.svg'
import git from '../img/svg/skills/git.svg'
import lightroom from '../img/svg/skills/lightroom.svg'
import figma from '../img/svg/skills/figma.svg'
import canva from '../img/svg/skills/canva.svg'
import laravel from '../img/svg/skills/laravel.svg'
import sqlite from '../img/svg/skills/sqlite.svg'
import renpy from '../img/svg/skills/renpy.svg'

export const skillsImage = (skill) => {
    const skillID = skill.toLowerCase();
    switch (skillID) {
        case 'html':
            return html;
        case 'photoshop':
            return photoshop;
        case 'css':
            return css;
        case 'angular':
            return angular;
        case 'javascript':
            return javascript;
        case 'react':
            return react;
        case 'php':
            return php;
        case 'python':
            return python;
        case 'git':
            return git;
        case 'lightroom':
            return lightroom;
        case 'figma':
            return figma;
        case 'canva':
            return canva;
        case 'laravel':
            return laravel
        case 'sqlite':
            return sqlite;
        case 'renpy':
            return renpy;
        default:
            break;
    }
}